

/*
	Source: htdocs/wim/js/core/src/Text.js
*/
(function($, wimbledonCore) {
function Text() {
        var id = 'Text';
        var logger = new eventsCore.util.Logger(id);
        var api = new Object();
        
      

        /**
         * watch for 'navB' style navigation identifier on page load and scroll to the related anchor
         * - call setup for waypoint listeners in page
         * @topDiv  selector for the top div which contains scrolling elements
         * @anchors selector for the option tags which contain anchor name
         */
        api.addEllipsis = function(element) {
            var el = $(element);
            var origHeight = el.height();
            var newHeight;
            var lastHeight;
            var textEnd = '...</span>';
            //logger.info('ellipsis - e:%o process:%o el-height:%o', el, (el.html().indexOf('...') < 0), el.height());

            if(el.css("overflow") == "hidden" && el.html().indexOf('...') < 0)
            {
                var multiline = el.hasClass('multiline');
                var t = $($(element)[0].cloneNode(true))
                        .hide()
                        .css('background-color', '#fff')
                        .css('z-index', '100')
                        .css('top', '5px')
                        .css('left', '240px')
                        .css('position', 'absolute')
                        .css('overflow', 'visible')
                        .css('font-size', '13px')
                        .css('font-family', '"Gotham 5r", Helvetica, Arial, sans-serif')
                        .css('text-align', 'left')
                        .width(multiline ? 212 : 'auto')
                        .height(multiline ? 'auto' : e1.height());

                el.after(t);
                //logger.info('ellipsis - t-size:%o e-size:%o', t.width() + 'x' + t.height(), el.width() + 'x' + el.height());

                function height() { return t.height() >= el.height()  };
                function width() { return t.width() >= el.width(); };

                //logger.info('ellipsis - multi:%o w:%o h:%o', multiline, width(), height());

                var func = multiline ? height : width;
                //logger.info('ellipsis - func:%o len:%o', func(), text.length);

                var text = el.html();
                while (text !== textEnd && text.length > 0 && func())
                {
                    lastHeight = t.height();
                    //text = text.substr(0, text.length - 4);
                    text = text.substr(0, text.lastIndexOf(' '));
                    text = $.trim(text);
                    text += textEnd;
                    t.html(text);
                    //logger.info('ellipsis - text:%o t-height:%o e-height:%o', text , t.width()+'x'+t.height(), el.width()+'x'+el.height());
                }
                logger.info('ellipsis - finish t-height:%o len:%o', t.height(), text.length);
                el.html(t.html());
                newHeight = t.height();
                t.remove();

                //el.css('height', origHeight + 'px');
            }
        };

        return api;
    };

    wimbledonCore.text = new Text;

}(jQuery, window.wimbledonCore));